import React from 'react';
import { isLayout, Layout, RendererProps, WithClassname } from '@jsonforms/core';
import { getTrueFields } from '../../utils/getTrueFields';
import { ExtendedUISchemaElement } from './GroupRenderer';
import { useJsonForms } from '@jsonforms/react';

type LayoutRendererProps = RendererProps &
  WithClassname & {
    dark?: boolean;
  };

type ExtendedLayout = Layout & {
  label?: string;
};

export const HorizontalLayoutRenderer: React.FC<LayoutRendererProps> = ({
  schema,
  uischema,
  path,
  renderers,
  cells,
  dark,
}) => {
  const ctx = useJsonForms();
  const data = ctx.core?.data;

  const layout = uischema as ExtendedLayout;

  return (
    <div className="flex flex-col gap-4">
      {isLayout(uischema) && layout.label && (
        <div
          className={`border-brightGray flex gap-[8px] rounded-md border ${
            dark ? 'bg-pageBackgroundDark border-chineseBlack text-white' : 'bg-[#F6F9FF]'
          } p-[12px]`}
        >
          <div className="qc-form-label text-1824 font-medium capitalize">{layout.label}</div>
        </div>
      )}
      <div className="flex flex-wrap gap-4">
        {isLayout(uischema) &&
          layout.elements?.map((element, index) => {
            const trueFields = getTrueFields(
              (element as ExtendedLayout).elements as ExtendedUISchemaElement[],
              schema,
              data
            );
            const renderedElement = renderers
              ?.find(r => r.tester(element, schema, { rootSchema: schema, config: {} }) >= 0)
              ?.renderer({
                schema,
                uischema: element,
                path,
                renderers,
                cells,
                dark,
              });
            if (
              !renderedElement ||
              (element.type.toLowerCase() === 'group' && !trueFields?.length)
            ) {
              return null;
            }

            return (
              <div
                className={'flex-1'}
                key={index}
              >
                {renderedElement}
              </div>
            );
          })}
      </div>
    </div>
  );
};
